// src/services/WriteWithAIService.ts
import ApiTokenService from "../../../services/ApiTokenService";
import UtilService from "../../../services/UtilService";

const apiUrl: string | undefined = process.env.REACT_APP_NODE_API_URL;

const WriteWithAIService = () => {
    // If ApiTokenService needs navigation, you'd typically get it via a hook in the component
    // and pass it here, or instantiate ApiTokenService within the component hook.
    // For now, let's assume ApiTokenService handles navigation internally or doesn't need it for this call.
    const apiTokenService = ApiTokenService();

    /**
     * Fetches AI-generated text suggestions.
     * @param fieldName - Identifier for the type of content needed (e.g., 'jobTitle', 'jobDescription', 'emailSubject').
     * @param context - Optional existing text to provide context to the AI (e.g., for refinement).
     * @returns Promise containing the AI suggestion or an error.
     */
    const fetchAICompletion = async (fieldName: string, currentValue?: string, context?: string) => {
        await apiTokenService.apiToken(); // Ensure token is fresh if needed
        const headers = UtilService.getHeadersToken(); // Or getHeadersApiToken() depending on endpoint auth

        const payload = {
            fieldName: fieldName,
            currentValue: currentValue,
            context: context || "", // Send current text as context
        };

        try {
            // Use the correct axios instance from apiTokenService if it's configured
            const response = await apiTokenService.axiosInstance.post(
                `${apiUrl}/ai/write-with-ai`, // Your new AI endpoint
                payload,
                { headers }
            );

            // Assuming the backend responds with { success: true, suggestion: "..." }
            if (response.data && response.data.success) {
                return response.data;
            } else {
                // Handle cases where the API call succeeded but the operation failed
                throw new Error(response.data.message || 'AI generation failed');
            }
        } catch (error) {
            console.error("Error fetching AI completion:", error);
            // Rethrow or return a structured error object
            return Promise.reject(error);
        }
    };

    return {
        fetchAICompletion,
    };
};

export default WriteWithAIService;

